Alpine.data('mapScript', () => ({
    async initMap(route) {
        const position = { lat: 13, lng: 0 }
        const { Map } = await google.maps.importLibrary('maps')
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker'
        )

        const map = new Map(document.getElementById('map'), {
            zoom: 1.7,
            center: position,
            mapId: '89e458aa191e6121',
        })

        const markers = await fetch(route)
            .then((res) => {
                return res.json()
            })
            .then((res) =>
                res.forEach((coords) => {
                    coords.latitude = parseFloat(coords.latitude)
                    coords.longitude = parseFloat(coords.longitude)
                    if (!isNaN(coords.latitude) && !isNaN(coords.longitude)) {
                        const marker = new AdvancedMarkerElement({
                            map: map,
                            position: {
                                lat: coords.latitude,
                                lng: coords.longitude,
                            },
                        })
                    }
                })
            )

        window.signupMap = map
    },
}))
